import { injectable } from 'inversify'
import { ok, err, Result } from '@xlearn/common'
import { Module, VuexModule, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { lazyInject } from '@/app/container';
import { QuizStoreModule, QuizStoreModuleSymbol, QuizRole, PracticeDetails  } from '@/app/quiz'

export const PracticeStoreModuleSymbol = Symbol.for('PracticeStoreModule');

export type FindPracticeError = 'practices-not-loaded' | 'practice-not-found'

type Practice = {
  id: string
  title: string
  href: string
  parentTitle: string
  role: QuizRole
} & PracticeDetails

@injectable()
@Module({
  namespaced: true,
  name: 'practice',
  store,
  dynamic: true
})
export class PracticeStoreModule extends VuexModule {

  @lazyInject(QuizStoreModuleSymbol)
  private quizStoreModule: QuizStoreModule
    
  get findPractice() {

    const self = this
    return function (id: string): Result<Practice, FindPracticeError> {
      
      if (self.loadingPhase !== 'loaded') {
        return err('practices-not-loaded')
      }

      const found = self.practices.find(x => x.id === id)
      if (!found) {
        return err('practice-not-found')
      }

      return ok(found)
    }
  }

  get practices() {

    return this.quizStoreModule.quizzes.filter(x => x.hasPractice).map(quiz => {

      if (!quiz.hasPractice) { throw new Error('Coding error' )}

      return {
        id: quiz.id,
        title: quiz.title,
        href: quiz.href,
        parentTitle: quiz.context.parentTitle,
        role: quiz.role,
        ...quiz.practice
      }
    })
  }

  get loadingPhase() {
    return this.quizStoreModule.loadingPhase
  }
}

export default getModule(PracticeStoreModule);

